import React from 'react'
import { QuizProvider } from './src/context/QuizContext'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => (
  <QuizProvider>{element}</QuizProvider>
)
